<template>
  <el-main class="p-4 main-container w-full">
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <keep-alive :include="['user', 'music']">
          <component :is="Component" />
        </keep-alive>
      </transition>
    </router-view>
  </el-main>
</template>

<script setup lang="ts">
// 需要缓存的组件名称列表
const cachedViews = ['user', 'music']
</script>

<style scoped lang="scss">
.main-container {
  height: calc(100vh - 60px);
}
/* 页面切换动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
